import { queryOptions } from "@tanstack/react-query";

const pushNotificationsModule =
	import.meta.env.VITE_CAPACITOR_BUILD === "true"
		? import("@capacitor/push-notifications")
		: null;

export function buildPushNotificationsPermissionsQueryKey() {
	return ["capacitor-push-notifications-permissions"];
}

export function buildPushNotificationsPermissionsQuery() {
	return queryOptions({
		queryKey: buildPushNotificationsPermissionsQueryKey(),
		queryFn: () =>
			pushNotificationsModule
				? pushNotificationsModule.then((m) =>
						m.PushNotifications.checkPermissions(),
					)
				: Promise.reject(new Error("Push notifications are not supported")),
		enabled: !!pushNotificationsModule,
		networkMode: "always",
	});
}
